import { render, staticRenderFns } from "./MailFolders.vue?vue&type=template&id=48926e7e"
import script from "./MailFolders.vue?vue&type=script&lang=js"
export * from "./MailFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports